export const cellStickPositionFinder = (isSticky) => {
  const cellPosition = {};
  if (isSticky === "left") {
    cellPosition.position = "sticky";
    cellPosition.left = 0;
  }
  if (isSticky === "right") {
    cellPosition.position = "sticky";
    cellPosition.right = 0;
  }
  return cellPosition;
};
